import { default as classNames, default as cn } from 'classnames'
import { FC, memo } from 'react'

import { DustedText } from '@shared'
import { MessageData } from '@store'

import styles from '../Dialog.module.scss'
import { DialogImage } from './DialogImage'
import { DialogItem } from './DialogItem'
import { DialogStoryteller } from './DialogStoryteller'
import { MessageName } from './MessageName'

type Props = {
  message: MessageData
  id: string
}

export const Message: FC<Props> = memo(function Message({
  message,
  id,
}: Props) {
  const { messageType, data } = message

  const isPlayerMessage = messageType === 'base' && data.isPlayer
  let messageComponent: React.ReactNode
  switch (messageType) {
    case 'image':
      messageComponent = <DialogImage image={data.image} />
      break
    case 'base':
      messageComponent = (
        <DialogItem
          title={<MessageName name={data.author || ''} />}
          avatar={data.avatar || ''}
          roleplay={data.roleplay || ''}
        >
          <DustedText
            text={data.text}
            hasInitAnimation={!isPlayerMessage}
            className={cn({
              [styles.playerMessage]: isPlayerMessage,
            })}
          />
        </DialogItem>
      )
      break
    case 'storyteller':
      messageComponent = <DialogStoryteller text={data.text} />
      break
  }

  return (
    <div
      id={id}
      className={classNames({
        [styles.companionMessage]: !isPlayerMessage,
      })}
    >
      {messageComponent}
    </div>
  )
})
